import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserPipe } from "./user.pipe";
import { KeysPipe } from "./keys.pipe";
import { SafePipe } from "./safe.pipe";

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        UserPipe,
        KeysPipe,
        SafePipe
	],
	exports:[
        UserPipe,
        KeysPipe,
        SafePipe
	]
})
export class SharedPipesModule { }



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/pipes/shared-pipes.module.ts